import React, { useState, useEffect } from 'react'
import DataTable from '../Shared/DataTable/DataTable.js'
import * as FieldTypes from '../Shared/FieldTypes/FieldTypes.js'
import ItemDetailsPane from './ItemDetailsPane.js'
import AddItemPopup from './AddItemPopup.js'
import RemoveItemPopup from './RemoveItemPopup.js'
import * as CustomFunctions from './CustomFunctions.js'

const SrProjects = () => {

    let dataTableStructure = {};

    dataTableStructure.dataUrl = "/umbraco/api/SystematicReviewApi/Projects";
    dataTableStructure.getSingleItemUrl = "/umbraco/api/SystematicReviewApi/Project";
    dataTableStructure.pageTitle = "SR Groups";
    dataTableStructure.singleItemTitle = "SR Group";
    dataTableStructure.entityType = "srprojects";
    dataTableStructure.pageIcon = "fas fa-layer-group";
    dataTableStructure.breadcrumbs = [{ "Name": "SR Groups", "Link": "/your-medboard/sr-groups/" }]
    dataTableStructure.dataStructure = [];
    dataTableStructure.enableTags = false;
    dataTableStructure.hideAddButton = window.hideAddButton ? true : false;
    dataTableStructure.showSRProjectsArchiveFilter = true;
    dataTableStructure.showSRProjectsCompanyUserFilter = true;
    dataTableStructure.customRowClickFunction = CustomFunctions.rowClick;
    dataTableStructure.rowClickUrlToProjectSystematicReviews = "/your-medboard/systematic-reviews-menu/?groupId=";

    

    dataTableStructure.dataStructure.push({ name: "Title", field: "Title", width: "50%", sortable: true, renderWith: FieldTypes.FieldType_Text });
    //dataTableStructure.dataStructure.push({ name: "Description", field: "Description", width: "25%", sortable: true, renderWith: FieldTypes.FieldType_Text });
    dataTableStructure.dataStructure.push({ name: "Responsible", field: "ResponsiblePerson", width: "20%", sortable: true, renderWith: FieldTypes.FieldType_User });
    dataTableStructure.dataStructure.push({ name: "Deadline", field: "Deadline", width: "20%", sortable: true, renderWith: FieldTypes.FieldType_DateList });
    dataTableStructure.dataStructure.push({ name: "Actions", field: "Id", width: "10%", sortable: false, renderWith: FieldTypes.FieldType_SRProjectsItemMenu, isMultiField: ["Id", "Archived"] });

    //dataTableStructure.dataStructure.push({ name: "Actions", field: "ExpectedCompletionDate", width: "18%", sortable: true, renderWith: FieldTypes.FieldType_DateList });

    dataTableStructure.dataUrlParameters = { search: null, page: 1, orderByField: "Deadline", orderByType: "ASCENDING", }


    let CustomMenuBar = null;

    return (<>

        <DataTable dataTableStructure={dataTableStructure} ItemDetailsPane={ItemDetailsPane} AddItemPopup={AddItemPopup} RemoveItemPopup={RemoveItemPopup} CustomMenuBar={CustomMenuBar} />

    </>);

};


export default SrProjects;